<template>
  <div class="PageBox" style="padding-bottom: 52px">
		<van-nav-bar
		    fixed
		    :border="false"
		    :title="$t('postRecord[0]')"
		    left-arrow
		    @click-left="$router.go(-1)"
		>
		<template #right>
		    <div v-if="UserInfo.is_post == 1">
		      <router-link to="/postTask"><div>{{$t('postRecord[1]')}}</div></router-link>
		    </div>
		  </template>
		</van-nav-bar>
	 <div class="ScrollBox">	
	 <div class="description-box">
	     <h3>{{$t('moments[0]')}}</h3>
	     <p class="description-text">
	       {{$t('moments[1]')}}
	     </p>
	   </div>
	 <div style="display: flex;  justify-content: center;align-items: center;">
		 <div style="padding: 5% 0 5% 0;width: 84%;">
			 <div class="progress-container" 
			      style="position: relative; width: 95%; margin: 0 auto;">
			   <van-progress 
			     stroke-width="15"
			     :percentage="schedule"
			     color="#00c15d" />
			   <img 
			     v-if="schedule > 0"
			     class="progress-icon"
			     :src="`./static/images/bike.png`"
			     :style="iconStyle" />
			 </div>
			
		 </div>
		 <div class="getR" style="" @click="openShow()">{{$t('postRecord[9]')}}</div>
	 </div>
		<van-list
		  v-model="isLoad"
		  :finished="isFinished"
		  :finished-text="listData.length?$t('vanPull[0]'):$t('vanPull[1]')"
		  @load="onLoad"
		   :class="{Empty:!listData.length}"
		>
			<van-cell :border="false" title-class="post" class="TaskItem" v-for="item in listData" :key="item.id">
			  <template #title>
				<span style="color:#0a5e85">
					<van-image :src="`./static/head/${UserInfo.header}`" style="width:30px;vertical-align:middle;" />
				{{item.username}}
				</span>
				<h4 style="color:#666666;padding-left: 33px;padding-bottom: 5px;word-wrap: break-word;overflow-wrap: break-word;white-space: normal;">{{item.title}}</h4>
				<span  v-for="val in item.content" :key="val">
				   <img :src="val" style="width: 33%;" @click="onClickImage(val)">
				</span>
				<p style="display: block;">
				<span style="line-height: 33px;">{{item.add_time}} </span>
				<span style="float: right;width: 2rem;text-align: center;">
					<i>{{item.num}}</i>
					<i v-if="item.is_like==0" @click="like(item.id)" style="width: 100%;" data-score="1" class="van-icon van-icon-like-o van-rate__icon"><!----></i>
					<i v-if="item.is_like>0" style="width: 100%;" data-score="1"  class="van-icon van-icon-like van-rate__icon van-rate__icon--full"></i>
				</span>
				</p>
			  </template>
			</van-cell>
		</van-list>
		
    </div>
	<Footer />
	<!--公告-->
	<van-popup
	  v-model="showNotice"
	  v-if="InitData.talk && InitData.talk.length"
	  style="background: transparent; width: 80%; text-align: center"
	  @closed="showNotice = false"
	>
	<div>
		<img :src="`./static/images/FC.gif`" style="width: 100%;"/>
	</div>
	  <div
	    class="NoticePopupL"
	    v-if="InitData.talk && InitData.talk.length"
	    @click="$router.push(`/article/talk/${InitData.talk[currentIndex].id}`)"
	  >
	    <!-- <h3 style="background-color: #971d35;color: #fff;">{{ InitData.talk[currentIndex].title }}</h3> -->
	    <div class="txt">
	      <!-- <div style="color: #999; text-align: center;font-size: 16px;">{{ InitData.noticelist[currentIndex].title }}</div> -->
	      <div style="word-wrap:break-word;" v-html="InitData.talk[currentIndex].content"></div>
	    </div>
	    <!-- <div style="display: flex;justify-content: center;margin: 10px 0">
	      <van-button size="small" round block style="color: #fff;font-size: 16px;background: linear-gradient(to right, rgb(12 126 179), rgb(11 63 149));border: none;box-shadow: 5px 5px 10px 0 rgba(0, 0, 0, 0.3);width: 120px;margin-right: 10px;" :disabled="currentIndex==0"  @click.stop="preNotice">{{$t('home.noticeTitle[0]')}}</van-button>
	      <van-button size="small" round block style="color: #fff;font-size: 16px;background: linear-gradient(to right,#F7D981, #FF8A03);border: none;box-shadow: 5px 5px 10px 0 rgba(0, 0, 0, 0.3);width: 120px;" :disabled="currentIndex==InitData.talk.length-1" @click.stop="nextNotice">{{$t('home.noticeTitle[1]')}}</van-button>
	    </div> -->
	  </div>
	  <a class="close" href="javascript:;" @click="showNotice = false"><van-icon name="clear" color="rgba(255,255,255,.8)" size="2.5rem"
	  /></a>
	</van-popup>
	
	<van-popup v-model="showPopup" closeable @close="showPopup = false">
	    <van-image :src="currentImage" style="width:300px;" />
	</van-popup>
  </div>
</template>

<script>
export default {
  name: 'postRecord',
  components: {
  },
  props: [],
  data() {
    return {
      listData: '',
      isLoad: false,
      isFinished: false,
      isRefresh: false,
      pageNo: 0,
      isStore: false,
	  currentImage: '',
	  showPopup: false,
	  schedule:100,
	  reData:[],
	  currentIndex:0,
	    showService:false,
	  showNotice: false,
    }
  },
  computed: {
	  iconStyle() {
	      // 确保使用正确的进度值（schedule）
	      const progress = this.schedule > 97 ? 97 : this.schedule; // 防止图标溢出
	      return {
	        left: `calc(${progress}% - 13px)`, // 微调位置偏移
	        transform: 'translateX(-50%)',
	        transition: 'left 0.5s ease' // 添加平滑动画
	      }
	    }

  },
  watch: {
	  reData: {
	      handler(newVal) {
	        // 当统计数据更新时自动计算进度
	        this.schedule = Math.min(Math.round((newVal.day / newVal.total) * 100), 100);
	      },
	      deep: true,
	      immediate: true
	    }

  },
  created() {
    this.$parent.navBarTitle = this.$t('postRecord[0]')
    this.initData();
    this.$Model.GetUserInfo();
    this.$Model.GetPostingStatistics(data=>{
      if(data.code==1){
        this.reData = data.data;
      }
    })
	
    if (this.InitData.talk.length) {
      this.showNotice = true;
    }
  },
  mounted() {
    
  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
	  preNotice(){
	    this.currentIndex = this.currentIndex-1
	  },
	  nextNotice(){
	    this.currentIndex = this.currentIndex+1
	  },
	  getStr() {
	  	
	  	this.schedule = this.reData['proportion'];
	  	this.rating = 100;
	  	return this.reData['day']+"/"+this.reData['total'];
	  },
    onClickImage(image) {
      this.currentImage = image;
      this.showPopup = true;
    },  
    openShow() {
      if(this.reData['day'] < this.reData['total']){
        this.$Dialog.Toast(this.$t("postRecord[8]"));
      }else{
        this.$Model.GetRewards(data=>{
          if(data.code==1){
			  this.$Model.GetPostingStatistics(newData => {
			            if (newData.code == 1) {
			              this.reData = newData.data;
			              // 自动触发进度条更新
			              this.schedule = Math.min(
			                Math.round((newData.data.day / newData.data.total) * 100),
			                100
			              );
			            }
			          });
            this.$Dialog.Toast(data.code_dec);
          }else{
            this.$Dialog.Alert(data.code_dec);
        }
        });
      }
      
    },
    like(id) {
      this.$Model.doLikePost(id,data=>{
        this.getListData('init')
      });
    },  
    initData() {
      this.getListData('init')
    },
    onLoad() {
        this.getListData('load')
    },
    getListData(type) {
        this.isLoad = true
        this.isRefresh = false
        if(type=='load'){
          this.pageNo+=1
        }else{
          this.pageNo = 1
          this.isFinished = false
        }
		
        this.$Model.GetPostList({page_no: this.pageNo},data=>{
          this.isLoad = false
		  
          if(data.code==1){
			  
            if(type=='load'){
				
              this.listData = this.listData.concat(data.info);
            }else{
              this.listData = data.info
            }
            if(data.info.length < 10){
              this.isFinished = true
            }else{
              this.isFinished = false
            }
          }else{
            this.listData = ''
            this.isFinished = true
          }
        })
      },
      onRefresh() {
        this.getListData('init')
      },

  }
}
</script>
<style scoped>
	.progress-icon {
	  position: absolute;
	  bottom: 10px;  /* 根据视觉效果调整 */
	  z-index: 2;
	  filter: drop-shadow(2px 2px 2px rgba(0,0,0,0.2)); /* 添加立体感 */
	}
.NoticePopupL {
    background-color: #fff;
    background-size: contain;
    height: 21.25rem;
    border-radius:0 0 10px 10px;
    position: relative;
    text-align: center;
    display: flex;
    flex-direction: column;
}
.NoticePopupL h3 {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    font-size: 1.25rem;
    font-weight: 600;
    color: #fff;
    line-height: 3.125rem;
}
.NoticePopupL .txt{border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 5px;
    color: #999;
    flex: auto;
    text-align: justify;}
.txt>>>img{max-width:100%}
.van-pull-refresh{
  min-height: calc(100vh - 90px);
}
.van-list{
  overflow: hidden;
}
/deep/.van-nav-bar__title{
	color: #fff;
}
/deep/.van-nav-bar__right div{
	color: #fff;
}
.getR{
	border-radius: 1.25rem;
	width:15%;
	margin:0 auto;
	
	text-align: center; 
	background: linear-gradient(to right, #55aa00, #aaff7f);
	color: #fff;
}

.description-box {
  background: #f8f9fa;
  border-radius: 12px;
  margin: 15px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.description-box h3 {
  color: #0a5e85;
  font-size: 1.4em;
  margin-bottom: 12px;
  text-align: center;
}

.description-text {
  color: #666;
  font-size: 0.95em;
  line-height: 1.6;
  text-align: justify;
}

.getR {
  /* 保持原有渐变样式 */
  border-radius: 1.25rem;
  width: 15%;
  min-width: 80px;
  padding: 8px 12px;
  font-size: 0.9em;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

/* 移动端适配 */
@media (max-width: 768px) {
  .description-box {
    margin: 10px;
    padding: 15px;
  }
  
  .description-text {
    font-size: 0.85em;
  }
  
  .getR {
    width: 20%;
    font-size: 0.8em;
  }
}

</style>